import React from 'react';
import {
  HashimotoTestFieldEnum,
  TestsConnectorApollo,
  RemoveTestConnectorApollo,
} from '@front-activerse/common-components';
import LabTestsHistoryContainer from './LabTestsHistoryContainer';
import { useTimestamp } from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';
import { HashimotoTestMeasurementFieldEnum } from '../types';

export const TestsHistoryPage: React.FC = () => {
  const { timestamp2 } = useTimestamp();
  const { category } = useParams<{ category: HashimotoTestMeasurementFieldEnum }>();

  const createVariable = () => {
    switch (category) {
      case HashimotoTestMeasurementFieldEnum.TSH:
        return HashimotoTestFieldEnum.TSH;
      case HashimotoTestMeasurementFieldEnum.FT3:
        return HashimotoTestFieldEnum.FT3;
      case HashimotoTestMeasurementFieldEnum.FT4:
        return HashimotoTestFieldEnum.FT4;
      case HashimotoTestMeasurementFieldEnum.ANTI_TPO:
        return HashimotoTestFieldEnum.ANTI_TPO;
      case HashimotoTestMeasurementFieldEnum.ANTI_TG:
        return HashimotoTestFieldEnum.ANTI_TG;
      default:
        return undefined;
    }
  };

  return (
    <TestsConnectorApollo variable={createVariable()}>
      {({ ...testData }) => (
        <RemoveTestConnectorApollo>
          {({ removeTest }) => (
            <LabTestsHistoryContainer key={timestamp2} {...testData} removeTest={removeTest} />
          )}
        </RemoveTestConnectorApollo>
      )}
    </TestsConnectorApollo>
  );
};

export default TestsHistoryPage;
